import { IGetProjetosDropDownUseCase } from "../../../presentation/useCases/read/get_projetos_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetProjetosDropDownUseCase
 */

export class GetProjetosDropDownUseCase implements IGetProjetosDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async execute(idCentroCusto?: number): Promise<DropDown[]> {
    const result = await this.repository.getProjetosDropDown(idCentroCusto ?? 0);
    return result;
  }

}
